var _linearGradient, _clipPath, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMongodb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 20,
    role: "img",
    "aria-label": "MongoDB",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MongoDB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 20,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0,
    height: 20,
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 81,
    height: 20,
    fill: "#4ea94b"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 3,
    width: 14,
    height: 14,
    href: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJ3aGl0ZSIgcm9sZT0iaW1nIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHRpdGxlPk1vbmdvREI8L3RpdGxlPjxwYXRoIGQ9Ik0xNy4xOTMgOS41NTVjLTEuMjY0LTUuNTgtNC4yNTItNy40MTQtNC41NzMtOC4xMTUtLjI4LS4zOTQtLjUzLS45NTQtLjczNS0xLjQ0LS4wMzYuNDk1LS4wNTUuNjg1LS41MjMgMS4xODQtLjcyMy41NjYtNC40MzggMy42ODItNC43NCAxMC4wMi0uMjgyIDUuOTEyIDQuMjcgOS40MzUgNC44ODggOS44ODRsLjA3LjA1QTczLjQ5IDczLjQ5IDAgMDExMS45MSAyNGguNDgxYy4xMTQtMS4wMzIuMjg0LTIuMDU2LjUxLTMuMDcuNDE3LS4yOTYuNjA0LS40NjMuODUtLjY5M2ExMS4zNDIgMTEuMzQyIDAgMDAzLjYzOS04LjQ2NGMuMDEtLjgxNC0uMTAzLTEuNjYyLS4xOTctMi4yMTh6bS01LjMzNiA4LjE5NXMwLTguMjkxLjI3NS04LjI5Yy4yMTMgMCAuNDkgMTAuNjk1LjQ5IDEwLjY5NS0uMzgxLS4wNDUtLjc2NS0xLjc2LS43NjUtMi40MDV6Ii8+PC9zdmc+"
  }), /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 495,
    y: 150,
    fill: "#010101",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 530
  }, "MongoDB"), /*#__PURE__*/React.createElement("text", {
    x: 495,
    y: 140,
    transform: "scale(.1)",
    fill: "#fff",
    textLength: 530
  }, "MongoDB"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongodb);
export default __webpack_public_path__ + "static/media/mongodb.30e3d80cb947793cd3b3e522a33e9805.svg";
export { ForwardRef as ReactComponent };